/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
// material
import { Page, InContentMessage, LoadState, Content } from '@insticator/insticator-ui'; // iui-material
// pages
import RatingsManager from 'pages/dashboard/ratings/ratingsmanager/ratingsmanager_container';
import RequestRatingWidget from 'pages/dashboard/ratings/requestratingwidget/requestratingwidget_container';
// utils
import { PrivateRoute } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/ratings/ratings_styles';



/* ========== ~~~~~~~~~~ RATINGS ~~~~~~~~~~ ========== */
const Ratings = (props) => {
    // _getPermittedPath is used to ensure user navigates to the first permitted tab.
    // If user doesn't have permissions to see any settings they will be redirected to the 403 error page
    const requestApproved = props.requestStatus === "APPROVED";
    const permittedToRequest = () => !props.dataFetchFailed && !requestApproved;
    const permittedToManager = () => (!props.dataFetchFailed && requestApproved) || (props.mockupGenerator && props.hasRatingsUnit);

    const _getPermittedPath = () => {
        // in here we will check if user has been approved from Ratings yet
        //if (props.mockupGenerator) return `/dashboard/ratings/${ props.hasRatingsUnit ? 'commentmanager' : 'requestwidget' }`;
        if(requestApproved){
            return '/dashboard/ratings/ratingsmanager';
        }
        return '/dashboard/ratings/requestwidget';
    };

    if(props.permissions.length < 1 || (props.fetchingRatingsData && !props.isDataReceived)) return <Content><LoadState /></Content>; // Waits for permissions.
    return(
        <Page name={`ratings`} klass={`${props.classes.ratings}`}>
            <InContentMessage/>
            <Switch>
                {/*Routes to subsections*/}
                <Route exact path={'/dashboard/ratings'} render={() => <Redirect to={_getPermittedPath()} />} />
                <PrivateRoute permitted={permittedToRequest()} redirectTo={_getPermittedPath()} path={'/dashboard/ratings/requestwidget'} component={RequestRatingWidget} />
                <PrivateRoute permitted={permittedToManager()} redirectTo={_getPermittedPath()} path={'/dashboard/ratings/ratingsmanager'} component={RatingsManager} />
                <Redirect to='/error/404' />
            </Switch>
        </Page>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Ratings);
